import { render, staticRenderFns } from "./triplea-success.vue?vue&type=template&id=6a6034f4&scoped=true"
import script from "./triplea-success.vue?vue&type=script&lang=js"
export * from "./triplea-success.vue?vue&type=script&lang=js"
import style0 from "./triplea-success.vue?vue&type=style&index=0&id=6a6034f4&prod&scoped=true&lang=css"
import style1 from "./triplea-success.vue?vue&type=style&index=1&id=6a6034f4&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6034f4",
  null
  
)

export default component.exports